if (!customElements.get('halloway-mobile-video')) {
  customElements.define('halloway-mobile-video', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.video = this.querySelector('video');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.failed = false;
      const rect = this.getBoundingClientRect();
      this.inView = rect.bottom > 0 && rect.top < window.innerHeight;
      this.sync = () => this.update();
      this.mobile.addEventListener('change', this.sync, options);
      this.motion.addEventListener('change', this.sync, options);
      document.addEventListener('visibilitychange', this.sync, options);
      this.video.addEventListener('playing', () => {
        clearTimeout(this.timer);
        this.classList.add('is-ready');
      }, options);
      this.video.addEventListener('error', () => this.fallback(), options);
      this.video.addEventListener('waiting', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.fallback(), 4500);
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.update();
      });
      this.observer.observe(this);
      this.update();
    }
    clearVideo() {
      clearTimeout(this.timer);
      this.video.pause();
      if (this.video.hasAttribute('src')) {
        this.video.removeAttribute('src');
        this.video.load();
      }
      this.classList.remove('is-ready');
    }
    fallback() {
      if (!this.isConnected) return;
      this.failed = true;
      this.clearVideo();
    }
    update() {
      const connection = navigator.connection;
      if (!this.mobile.matches || this.motion.matches || connection?.saveData ||
          /(^|-)2g$/.test(connection?.effectiveType || '') || this.failed) {
        this.clearVideo();
        return;
      }
      if (!this.inView || document.hidden) {
        clearTimeout(this.timer);
        this.video.pause();
        return;
      }
      if (!this.video.hasAttribute('src')) {
        this.video.muted = true;
        this.video.src = this.dataset.videoSrc;
        this.video.load();
      }
      if (!this.classList.contains('is-ready')) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.fallback(), 4500);
      }
      const play = this.video.play();
      if (play) play.catch(error => {
        if (error.name !== 'AbortError') this.fallback();
      });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.video?.pause();
      this.abort = null;
    }
  });
}
